import React, { useState } from 'react';
import { StyledAddress, StyledListItem } from './style';
import { SpaceProps } from 'styled-system';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import Icon from '../../Common/Icon';
import { ClubLinkBranchInfoType } from '../../../Types/landing.type';
import { useTranslation } from 'react-i18next';
import BranchActionSheet from '../BranchActionSheet';

type ListItemType = SpaceProps & {
  branchData: ClubLinkBranchInfoType;
};

const ListItem: React.FC<ListItemType> = ({ branchData, ...rest }) => {
  const { t } = useTranslation();
  const [isOpenActionSheet, setIsOpenActionSheet] = useState(false);

  return (
    <>
      <StyledListItem
        onClick={() => {
          setIsOpenActionSheet(true);
        }}
        {...rest}>
        <StyledDiv
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%">
          <StyledDiv>
            <Icon name="store" fontSize={18} color="normalText" />
            <StyledSpan color="normalText" fontSize={4} mr={5}>
              {branchData.branchName}
            </StyledSpan>
          </StyledDiv>
          <StyledDiv>
            <Icon name="info" fontSize={10} color="primaryBlue" ml={5} />
            <StyledSpan color="primaryBlue" fontSize={4}>
              {t('branches.branchInfo')}
            </StyledSpan>
          </StyledDiv>
        </StyledDiv>
        <StyledAddress mt={7}>
          {branchData.contactUsViewModel.address || '-'}
        </StyledAddress>
      </StyledListItem>
      <BranchActionSheet
        branchData={branchData}
        id={String(branchData.clubBranchId)}
        open={isOpenActionSheet}
        onDismiss={setIsOpenActionSheet}
        hasCreditButton
      />
    </>
  );
};

export default ListItem;
